
if (!customElements.get('pickup-availability')) {
    const currency_Symbols = {
        AED: "Dhs.",
        AFN: "؋",
        ALL: "Lek",
        AMD: "AMD",
        ANG: "Ƒ;",
        AUD: "$",
        AWG: "Afl",
        AZN: "m.",
        BAM: "KM",
        BBD: "$",
        BDT: "Tk",
        BGN: "лв",
        BIF: "FBu.",
        BND: "$",
        BOB: "Bs",
        BSD: "BS$",
        BWP: "P",
        BZD: "BZ$",
        CAD: "$",
        CDF: "FC",
        CHF: "CHF",
        CNY: "¥",
        CRC: "₡",
        CVE: "$",
        CZK: "Kč",
        DJF: "Fdj",
        DKK: "kr",
        DOP: "RD$",
        DZD: "DA",
        EGP: "LE",
        ETB: "Br",
        EUR: "€",
        FJD: "$",
        FKP: "£",
        GBP: "£",
        GMD: "D",
        GNF: "FG",
        GTQ: "Q",
        GYD: "G$",
        HKD: "$",
        HNL: "L",
        HUF: "Ft",
        IDR: "Rp",
        ILS: "NIS",
        INR: "Rs. ",
        ISK: "kr",
        JMD: "$",
        JPY: "¥",
        KES: "KSh",
        KGS: "Лв",
        KHR: "KHR",
        KMF: "CF",
        KRW: "₩",
        KYD: "$",
        KZT: "₸",
        LAK: "₭",
        LBP: "L£",
        LKR: "Rs",
        MAD: "dh",
        MDL: "MDL",
        MKD: "ден",
        MMK: "K",
        MNT: "₮",
        MOP: "MOP$",
        MUR: "Rs ",
        MVR: "Rf",
        MWK: "MK",
        MXN: "$",
        MYR: "RM",
        NGN: "₦",
        NIO: "C$",
        NOK: "kr",
        NPR: "Rs",
        NZD: "$",
        PEN: "S/. ",
        PGK: "K",
        PHP: "₱",
        PKR: "Rs.",
        PLN: " zł",
        PYG: "Gs.",
        QAR: "QAR",
        RON: "lei",
        RSD: "дин.",
        RWF: "RF",
        SAR: "SR",
        SBD: "$",
        SEK: "kr",
        SGD: "$",
        SHP: "£",
        SLL: "Le ",
        STD: "Db",
        THB: "฿",
        TJS: "RJS",
        TOP: "$",
        TTD: "$",
        TWD: "$",
        TZS: "TZS",
        UAH: "₴",
        UGX: "USh",
        USD: "$",
        UYU: "$",
        UZS: "som",
        VND: "₫",
        VUV: "$",
        WST: "WS$",
        XAF: "FCFA ",
        XCD: "$",
        XOF: "CFA",
        XPF: " XPF",
        YER: "YER"
      };
      var currentCurrency_selected = document.getElementById("currencies").value,
        currencySymbol_Selected = currency_Symbols[currentCurrency_selected];
            
    customElements.define('pickup-availability', class PickupAvailability extends HTMLElement {
      constructor() {
        super();
  
        if (!this.hasAttribute('available')) return;
  
        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }
  
      fetchAvailability(variantId) {
        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;
  
        fetch(variantSectionUrl)
          .then(response => response.text())
          .then(text => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch(e => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }
  
      onClickRefreshList(evt) {
        this.fetchAvailability(this.dataset.variantId);
      }
  
      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);
  
        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }
  
      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-preview')) {
          this.innerHTML = "";
          this.removeAttribute('available');
          return;
        }
  
        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-preview').outerHTML;
        this.setAttribute('available', '');
  
        document.body.appendChild(sectionInnerHTML.querySelector('pickup-availability-drawer'));
  
        const button = this.querySelector('button');
        if (button) button.addEventListener('click', (evt) => {
          document.querySelector('pickup-availability-drawer').show(evt.target);
        });
      }
    });
  }

var selectedVariant = document.querySelector('.product-variant-id')?.value;
if (selectedVariant) {
    window.history.replaceState({}, '', `?variant=${selectedVariant}`);
}
class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.toggleAddButton(true, '', false);
        this.sectionId = this.dataset.sectionId;
        this.addEventListener('change', (event) => {
            this.onVariantChange(event);
        });
        setTimeout(() => {
            // Removing the (disabled layer) when the variant-change file fully load. 
    
            let addToCartButton = document.querySelector('.special_atc_btn.button');
            let widthVariants = document.getElementsByClassName("width-variant-options")[0];
            if (addToCartButton) {
                addToCartButton.classList.remove("atc-disabled");
            }
            if (widthVariants) {
                widthVariants.classList.remove("disabled-width");
            }
            document.querySelectorAll('.disabled-class').forEach((element) => {
                element.classList.remove('disabled-class');
            })
        }, 1500)
    }

    onVariantChange(event) {

        var variantLabels = document.querySelectorAll('label.is-color');
        variantLabels.forEach(function (variantLabel) {
            variantLabel.removeAttribute('selected');
        });

        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateMediaWithoutVariant(event.target);

        if (!this.currentVariant) {
            (document.querySelectorAll('fieldset').length == document.querySelectorAll('fieldset input:checked').length) ? this.toggleAddButton(true, window.variantStrings.unavailable, true) : this.toggleAddButton(true, '', true);
            document.querySelector('product-form [name="add"]').classList.remove('sold--out');
            this.setUnavailable();
            document.querySelector('.product-form__buttons').classList.add('hidde');
            document.querySelector('.badges-wrapper-pdp').classList.add('hidde');
        } else {
            document.querySelector('.product-form__buttons').classList.remove('hidde');
            document.querySelector('.badges-wrapper-pdp').classList.remove('hidde');
            this.updateMedia();
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }

        var radioButtons = document.querySelectorAll('variant-radios .inputVariant');
        radioButtons.forEach(radioButton => {
            if (radioButton.hasAttribute('selected')) {
                radioButton.removeAttribute('selected');
            }
        });
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
                return this.options[index] === option;
            }).includes(false);
        });

    }

    updateMedia() {

        if (!this.currentVariant) return;
        if (!this.currentVariant.featured_media) return;
        var mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);

        // $('button[data-media-id="' + this.currentVariant.featured_media.id + '"]').parentsUntil(".slick-slide").find(".product__media-item").trigger("click");
        window.currentVariant = this.currentVariant;

        var mediaWrapper = document.querySelector('.featuredMediaImage');
        var imageWrapper = mediaWrapper.querySelector('img');


        imageWrapper.src = this.currentVariant.featured_image.src;
        imageWrapper.setAttribute('data-srcset', this.currentVariant.featured_image.src);
        imageWrapper.setAttribute('data-src', this.currentVariant.featured_image.src);
        imageWrapper.setAttribute('srcset', this.currentVariant.featured_image.src);

        var thumbMediaWrapper = document.querySelector('.featuredThumbMediaWrapper');

        if (thumbMediaWrapper) {
          const thumbImageWrapper = thumbMediaWrapper.querySelector('img');
  
          if (thumbImageWrapper) {
            thumbImageWrapper.src = this.currentVariant.featured_image.src;
            thumbImageWrapper.setAttribute('data-srcset', this.currentVariant.featured_image.src);
            thumbImageWrapper.setAttribute('data-src', this.currentVariant.featured_image.src);
            thumbImageWrapper.setAttribute('srcset', this.currentVariant.featured_image.src);
          }
        }

        document.querySelector('product-modal').querySelector('img').src = this.currentVariant.featured_image.src;
        document.querySelector('product-modal').querySelector('img').setAttribute('data-srcset', this.currentVariant.featured_image.src);
        document.querySelector('product-modal').querySelector('img').setAttribute('data-src', this.currentVariant.featured_image.src);
        document.querySelector('product-modal').querySelector('img').setAttribute('srcset', this.currentVariant.featured_image.src);
    }

    updateMediaWithoutVariant(handle) {
        var selectedColorInput = document.querySelector('.color-variant-swatches[option-name="Color"] input[name="Color"]:checked');
        var productHandle = selectedColorInput?.getAttribute('data-handle');
        if (handle) {
            productHandle = handle.dataset.handle;
        }
        var shouldSwapProduct = this.dataset.url !== `/products/${productHandle}`;
        var requestUrl = `/products/${productHandle}`;
        this.renderSection({
            requestUrl,
            callback: shouldSwapProduct
                ? this.handleSwapProduct(`/products/${productHandle}`, false)
                : this.renderProductInfo(`/products/${productHandle}`)
        });
        return;
    }
    
    getSelectedVariant(productInfoNode) {
        if (!productInfoNode) {
            //console.error('ProductInfoNode is null or undefined');
            return null;
        }
        var selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
    }

    handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {

            this.productModal?.remove();

            var selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
            var variant = this.getSelectedVariant(html.querySelector(selector));
            this.updateURL(productUrl, variant?.id);

            var priceWrapperInDom = document.querySelectorAll(`#price-${this.dataset.section}`);

            //   document.querySelector('.product-form__input[option-index="2"]').innerHTML = html.querySelector('.product-form__input[option-index="2"]').innerHTML;
            //   document.querySelector('.product-form__input[option-index="3"]').innerHTML = html.querySelector('.product-form__input[option-index="3"]').innerHTML;
            var updateContent = [
                'product-form',
                '.product__media-wrapper',
                '.badges-wrapper-pdp',
                'product-modal',
                '.reviewWidgetDynamic',
                'reviewsio-product-ratings'
            ];

            if (document.querySelector('.product-form__input[option-index="3"]') != null) {
                updateContent.push('.product-form__input[option-index="3"]');
            }
            if (document.querySelector('.product-form__input[option-index="2"]') != null) {
                updateContent.push('.product-form__input[option-index="2"]');
            }

            updateContent.forEach(item => {
                HTMLUpdateUtility.viewTransition(
                    document.querySelector(item),
                    html.querySelector(item),
                    this.preProcessHtmlCallbacks,
                    this.postProcessHtmlCallbacks
                );
            })

            var productTitle = document.querySelectorAll('.product__title')
            productTitle.forEach(title => {
                var productTitleHtml = html.querySelector('.product__title');
                if (productTitleHtml) {
                    title.innerHTML = productTitleHtml.innerHTML;
                }
            })

            this.loadRatingSnippet();
            var priceElement = html.querySelector('variant-radios');

            priceWrapperInDom.forEach(priceWrapper => {
                if (priceElement){
                    priceWrapper.innerHTML = html.querySelector(`#price-${priceElement.dataset.section}`).innerHTML;
                };
            })

        };
    }
    loadRatingSnippet() {
        ratingSnippet("ruk_rating_snippet", {
            store: "bartonwatchbands",
            mode: "default",
            color: "#0E1311",
            linebreak: false,
            text: "Reviews",
            singularText: "Review",
            lang: "en",
            usePolaris: true,
            showEmptyStars: false,
        });
    }

    renderSection({ requestUrl, callback }) {
        fetch(requestUrl)
            .then((response) => response.text())
            .then((responseText) => {
                this.pendingRequestUrl = null;
                var html = new DOMParser().parseFromString(responseText, 'text/html');
                var MainContent = html.getElementById("MainContent");
                console.log(MainContent);
                callback(html);
            })
            .catch((error) => {
                if (error.name === 'AbortError') {
                    console.log('Fetch aborted by user');
                } else {
                    console.error(error);
                }
            });
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        var shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {

        var productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
            var input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    updateVariantStatuses() {
        var selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
        var inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            var optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
            var previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            var availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue)
        });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach(input => {
            if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
                input.innerText = input.getAttribute('value');
            } else {
                input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
            }
        });
    }

    updatePickupAvailability() {
        var pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;
        var removeDateWhenSoldOut = document.getElementById('delivery_time_estimate_ecom');
        if (!removeDateWhenSoldOut) return;
        if (pickUpAvailability && removeDateWhenSoldOut != undefined && this.currentVariant && this.currentVariant.available) {
            removeDateWhenSoldOut.style.display = "flex";
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            removeDateWhenSoldOut.style.display = "none";
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        var section = this.closest('section');
        if (!section) return;
        var productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
        var specialCurrencies = ["YER", "UZS", "VND", "UGX", "XPF", "MNT", "NYN", "SAR", "RWF", "SEK", "THB", "RSD", "RON", "PLN", "MDL", "MAD", "KMF", "ISK", "ILS", "HUF", "DKK", "DJF", "CZK", "CVE", "BGN", "AMD"];
    
        if (!this.currentVariant) {
            console.error('Current variant is not defined.');
            return;
        }
    
        var requestedVariantId = this.currentVariant.id;
        var sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        var addButtonUpdated = document.getElementById(`ProductSubmitButton-${sectionId}`);
        var newVariant = window.allVariants.find(e => { return e.id == requestedVariantId; });
    
        if (!newVariant) {
            console.error(`No variant found for ID: ${requestedVariantId}`);
            return;
        }
    
        var selVarPrice = newVariant.price / 100;
        var priceToShow = selVarPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        var destinations = document.querySelectorAll('.price-item--regular');
        var priceFromText = destinations[0].querySelector('.from');
        var atcButtonForPrice = document.querySelector('.special_atc_btn');
        var isAvailable = newVariant.available;
    
        if (specialCurrencies.includes(document.getElementById("currencies").value)) {
            atcButtonForPrice.innerHTML = `ADD TO CART - ${priceToShow}${currencySymbol_Selected}`;
            this.updatePrice(destinations, priceToShow, currencySymbol_Selected, priceFromText);
        } else {
            atcButtonForPrice.innerHTML = `ADD TO CART - ${currencySymbol_Selected}${priceToShow}`;
            this.updatePrice(destinations, priceToShow, currencySymbol_Selected, priceFromText);
        }
        this.toggleAddButton(!isAvailable, '', true);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);
        this.toggleAddButton(!this.currentVariant.available, '', true);
        !this.currentVariant.available ? document.querySelector('#klaviyo-btn-pdp-page').classList.add('sold--out-visible') : document.querySelector('#klaviyo-btn-pdp-page').classList.remove('sold--out-visible');
        !this.currentVariant.available ? document.querySelector('product-form [name="add"]').classList.add('sold--out') : document.querySelector('product-form [name="add"]').classList.remove('sold--out');
        !this.currentVariant.available ? document.querySelector('.price__badge-sold-out').classList.add('badge-sold-out-visible') : document.querySelector('.price__badge-sold-out').classList.remove('badge-sold-out-visible');
        !this.currentVariant.available ? document.querySelector('#klaviyo-btn-pdp-page').classList.remove('invisible') : null;
    }
    

    //Update price on all places in the page
    updatePrice(destinations, priceToShow, currencySymbol_Selected, priceFromText) {
        if (priceFromText) {
            destinations.forEach((destination) => {
                destination.innerHTML = `<span class="from">from </span> ${currencySymbol_Selected}${priceToShow}`;
            });
        } else {
            destinations.forEach((destination) => {
                destination.innerHTML = `${currencySymbol_Selected}${priceToShow}`;
            });
        }
    }
    toggleAddButton(disable = true, text, modifyClass = true) {
        var productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        var addButton = productForm.querySelector('[name="add"]');
        var addButtonText = productForm.querySelector('[name="add"] > span') || productForm.querySelector('[name="add"]');
        if (!addButton) return;
        if (disable) {
            if (text == 'Unavailable' || text == 'unavailable')
                addButton.classList.add('unavailable');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.classList.remove('unavailable');
            addButton.removeAttribute('disabled');
        }
        if (!modifyClass) return;
    }

    setUnavailable() {
        var button = document.getElementById(`product-form-${this.dataset.section}`);
        var addButton = button.querySelector('[name="add"]');
        var addButtonText;
        addButtonText = button.querySelector('[name="add"] > span');
        if (!addButton) return;
        if (addButtonText == null) {
            addButtonText = button.querySelector('[name="add"]');
        }
        addButtonText.text = window.variantStrings.unavailable;
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();

    }

    updateOptions() {

        var fieldSets = Array.from(this.querySelectorAll('fieldset'));
        this.options = fieldSets.map((fieldset) => {
            if (Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked) != undefined) {
                return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
            }
        });

        if (fieldSets.length == 3) {
            var possibleVariants = this.getVariantData().filter(variant => variant.option1 === this.options[0]);
            if (this.options[0] !== undefined) {
                var inputs1 = document.querySelectorAll("variant-radios fieldset:nth-of-type(2) input");
                var inputs2 = document.querySelectorAll("variant-radios fieldset:nth-of-type(3) input");

                inputs1.forEach(input => {
                    input.classList.add('unavailable');
                    input.classList.remove('available');
                });

                inputs2.forEach(input => {
                    input.classList.remove('available');
                });
            }
            for (var index = 0; index < possibleVariants.length; index++) {
                var variant = possibleVariants[index]
                var input = document.querySelector(`[value='${variant.option2}']`)
                if (input) {
                    if (!variant.available) {
                        input.classList.add('unavailable');
                        if (!input.classList.contains('available')) {
                        }
                    } else {
                        input.classList.remove('unavailable')
                        input.classList.remove('unavailable');
                        input.classList.add('available')
                        input.disabled = false;
                    }
                }
            }

            var colorVar = document.querySelector("variant-radios fieldset:nth-of-type(2) input:checked")?.value;
            var possibleVariants3 = this.getVariantData().filter(variant => variant.option1 === this.options[0]);

            possibleVariants3 = possibleVariants3.filter(variant => variant.option2 === this.options[1]);
            if (colorVar != undefined) {
                if (this.options[1] != undefined) {
                    document.querySelectorAll("variant-radios fieldset:nth-of-type(3) input").forEach(input => {
                        input.classList.add('unavailable');
                        input.classList.add('hide');
                        input.classList.remove('available');
                        input.setAttribute("marked", "");
                    });
                }
                for (var index = 0; index < possibleVariants3.length; index++) {
                    var variant = possibleVariants3[index]
                    var input = document.querySelector(`[value='${variant.option3}']`)
                    if (input) {
                        if (!variant.available) {
                            input.classList.add('unavailable');
                            if (!input.classList.contains('available')) {
                            }

                        } else {
                            input.classList.remove('unavailable');
                            input.classList.add('available')
                            input.disabled = false;
                        }
                    }
                }
            }
        }
        else if (fieldSets.length == 2) {
            var possibleVariants = this.getVariantData().filter(variant => variant.option1 === this.options[0]);
            if (this.options[0] != undefined) {
                document.querySelectorAll("variant-radios fieldset:nth-of-type(2) input").forEach(input => {
                    input.classList.add('unavailable');
                    input.classList.remove('available');
                });
            }

            for (var index = 0; index < possibleVariants.length; index++) {
                var variant = possibleVariants[index]
                var input = document.querySelector(`[value='${variant.option2}']`)
                if (input) {
                    if (!variant.available) {
                        input.classList.add('unavailable');
                        if (!input.classList.contains('available')) {
                        }
                    } else {
                        input.classList.remove('unavailable');
                        input.classList.add('available')
                        input.disabled = false;
                    }
                }
            }
            var colorVar = $("variant-radios fieldset:eq(1) input:checked").val();
            var possibleVariants2 = this.getVariantData().filter(variant => variant.option1 === this.options[0]);
            if (colorVar != undefined) {

                if (this.options[0] !== undefined) {
                    const fieldsets = document.querySelectorAll(".variant-radios fieldset");
                    if (fieldsets.length > 1) {
                        const inputs = fieldsets[1].querySelectorAll("input");
                        inputs.forEach(input => {
                            input.classList.add('unavailable');
                            input.classList.add('hide');
                            input.classList.remove('available');
                            input.setAttribute("marked", "");
                        });
                    }
                }

                for (var index = 0; index < possibleVariants2.length; index++) {
                    var variant = possibleVariants2[index]
                    var input = document.querySelector(`[value='${variant.option2}']`)
                    if (input) {
                        if (!variant.available) {
                            input.classList.add('unavailable');
                            if (!input.classList.contains('available')) {
                            }
                        } else {
                            input.classList.remove('unavailable');
                            input.classList.add('available')
                            input.disabled = false;
                        }
                    }
                }
            }
        }
    }
}

customElements.define('variant-radios', VariantRadios);


class HTMLUpdateUtility {
    /**
     * Used to swap an HTML node with a new node.
     * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
     *
     * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
     */
    static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
        if (!newContent) {
            //console.error('newContent is null; skipping view transition.');
            return;
        }
        preProcessCallbacks?.forEach((callback) => callback(newContent));

        var newNodeWrapper = document.createElement('div');
        HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
        var newNode = newNodeWrapper.firstChild;

        // dedupe IDs
        var uniqueKey = Date.now();
        oldNode.querySelectorAll('[id], [form]').forEach((element) => {
            element.id && (element.id = `${element.id}-${uniqueKey}`);
            element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
        });

        oldNode.parentNode.insertBefore(newNode, oldNode);
        oldNode.style.display = 'none';
        document.querySelector('.badges-wrapper-pdp').style.opacity = '1';
        postProcessCallbacks?.forEach((callback) => callback(newNode));

        setTimeout(() => oldNode.remove(), 500);

        var variantBlockLoaders = document.querySelectorAll('.variant-loading');
        var loaderBlocking = document.querySelector('.main-product-section-wrapper');

        if (variantBlockLoaders) {
            variantBlockLoaders.forEach(loader => {
                loader.style.display = 'none';
            });
        }
        if (loaderBlocking && loaderBlocking.classList) {
            loaderBlocking.classList.remove('loading-blocking');
        }

    }

    // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    static setInnerHTML(element, html) {
        element.innerHTML = html;
        element.querySelectorAll('script').forEach((oldScriptTag) => {
            var newScriptTag = document.createElement('script');
            Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
            });
            newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
            oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

    }

}

